export const LAUNDRY_MIN_LEAD_HOURS = 24;

// Earliest allowed laundry pickup: now + 24h (minute precision, since the
// inputs only carry HH:mm)
export const getMinPickupDate = () => {
  const d = new Date(Date.now() + LAUNDRY_MIN_LEAD_HOURS * 60 * 60 * 1000);
  d.setSeconds(0, 0);
  return d;
};

// Value to prefill the pickers with: min pickup rounded up to the next full
// hour, so the default stays valid while the guest fills in the form
export const getDefaultPickupDate = () => {
  const d = getMinPickupDate();
  if (d.getMinutes() > 0) {
    d.setHours(d.getHours() + 1);
    d.setMinutes(0);
  }
  return d;
};

// Local YYYY-MM-DD (toISOString is UTC and shifts the day for UTC+4 users)
export const toDateInputValue = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate(),
  ).padStart(2, "0")}`;

// Local HH:mm
export const toTimeInputValue = (d) =>
  `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(
    2,
    "0",
  )}`;

// true when "<date>T<time>" is at least LAUNDRY_MIN_LEAD_HOURS from now
export const isPickupAtLeast24hAway = (date, time) => {
  const pickup = new Date(`${date}T${time}`);
  return !isNaN(pickup) && pickup.getTime() >= getMinPickupDate().getTime();
};
